export enum EnumTipoConfigGroupPay {
    DESPESAS_ENCONTRADAS = "Despesas Encontradas por IA",
    CONFIGURACAO_GROUP_PAY = "Configurações do Group Pay"
}